import { Injectable, NgModuleRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ModalService } from '@bayclubs/utils';
import { HorizonToastService } from '@bayclubs/horizon';

import { SubBoardApiService, GroupClassesApiService } from '../../shared/shared.module';
import { RecurringClassActionConfirmationComponent } from '../components/recurring-class-action-confirmation/recurring-class-action-confirmation.component';

@Injectable({
    providedIn: 'root'
})
export class RemoveClassService {
    constructor(
        private translate: TranslateService,
        private subBoardApi: SubBoardApiService,
        private groupClassApi: GroupClassesApiService,
        private toast: HorizonToastService,
        private modalService: ModalService,
        private moduleRef: NgModuleRef<any>
    ) {}

    public removeClass(event: { isRecurring: boolean; id: string }, continuation: () => void, clubId: string) {
        const bodyText: string = event.isRecurring
            ? this.translate.instant('GroupClassDetails.CancellationRecurringConfirmationText')
            : this.translate.instant('GroupClassDetails.DeleteConfirmationText');

        const headerText: string = this.translate.instant('GroupClassDetails.DeleteConfirmationTitle');

        const params = {
            event,
            warningBar: true,
            bodyText: bodyText,
            headerText: headerText,
            confirmed: (includeFollowing: boolean) => {
                this.subBoardApi.getOpenRequest(clubId, event.id).subscribe(response => {
                    const hasOpenSubstitutionRequest = response != null;
                    if (hasOpenSubstitutionRequest) {
                        this.toast.error(this.translate.instant('GroupClassDetails.SubstitutionRequestExistsError'));
                    } else {
                        this.groupClassApi.delete(event.id, includeFollowing).subscribe(() => {
                            this.toast.success(this.translate.instant('Utils.OperationOk'));
                            continuation();
                        });
                    }
                });
            }
        };

        this.modalService
            .create<RecurringClassActionConfirmationComponent>(
                RecurringClassActionConfirmationComponent,
                params,
                this.moduleRef,
                '#confirmationModal'
            )
            .subscribe(() => {});
    }
}
